(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4218],{

/***/ 34101:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/community/[id]",
      function () {
        return __webpack_require__(31961);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atom_Skeleton; }
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/opacity.ts + 1 modules
var opacity = __webpack_require__(52172);
;// CONCATENATED MODULE: ./src/components/atom/Skeleton/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  to {\n    background-position-x: -20%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 5px;\n  ",
        "\n  background-size: 200% 100%;\n  background-position-x: 180%;\n  animation: 1.6s ",
        " ease-in-out infinite;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var loading = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var StyledSkeleton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a4c00a2-0"
})(_templateObject1(), function(param) {
    var _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? theme/* default.color.gray40 */.Z.color.gray40 : _backgroundColor, _gradientColor = param.gradientColor, gradientColor = _gradientColor === void 0 ? "#ffffff" : _gradientColor;
    return "\n    background-color: ".concat(backgroundColor, ";\n    background: linear-gradient(\n        120deg,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "0%"), " 40%,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "50%"), " 50%,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "0%"), " 60%\n      )\n      ").concat(backgroundColor, ";\n  ");
}, loading);

;// CONCATENATED MODULE: ./src/components/atom/Skeleton/index.tsx



var Skeleton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkeleton, (0,_object_spread/* default */.Z)({}, props));
};
/* harmony default export */ var atom_Skeleton = (Skeleton);


/***/ }),

/***/ 4794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44376);


var AlertInformationCircle = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.blue500 */ .Z.color.blue500 : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_3123_59414)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.70893 0.0037226C7.37613 0.0197098 7.16646 0.0379306 6.89933 0.0740906C5.80564 0.222135 4.72396 0.613463 3.77293 1.20518C2.68753 1.88048 1.75169 2.83911 1.10394 3.93917C0.969856 4.16688 0.788212 4.52054 0.685127 4.75461C0.319981 5.58371 0.105479 6.41796 0.0292292 7.30557C0.00730277 7.5608 0.00341797 7.66523 0.00341797 7.99997C0.00341797 8.38046 0.0129412 8.56948 0.0483972 8.89277C0.177127 10.0664 0.575706 11.2152 1.20534 12.2272C1.74277 13.091 2.464 13.8659 3.29613 14.4736C3.94176 14.9451 4.69257 15.3318 5.46253 15.5894C6.06849 15.7921 6.66726 15.916 7.30573 15.9709C7.56097 15.9928 7.6654 15.9967 8.00013 15.9967C8.38062 15.9967 8.56964 15.9872 8.89293 15.9517C10.0665 15.823 11.2154 15.4243 12.2273 14.7948C13.0311 14.2947 13.7568 13.6367 14.3464 12.8736C14.8799 12.1829 15.3085 11.3776 15.5895 10.5376C15.7878 9.94484 15.9111 9.3564 15.9683 8.73013C15.9799 8.60255 15.9937 8.37658 15.9937 8.31234C15.9937 8.27792 15.9966 8.24856 16.0001 8.24637C16.0042 8.24384 16.0065 8.1523 16.0065 7.99281C16.0065 7.82804 16.0044 7.74455 16.0001 7.74717C15.996 7.7497 15.9937 7.72856 15.9937 7.68834C15.9937 7.58311 15.9739 7.30934 15.9518 7.10717C15.8236 5.93509 15.4244 4.78457 14.7949 3.77277C14.2576 2.90911 13.5361 2.13395 12.7041 1.52635C12.0584 1.05476 11.3113 0.669937 10.5377 0.4105C9.88079 0.190167 9.25042 0.0667946 8.51888 0.0153962C8.39123 0.0064298 7.82309 -0.0017558 7.70893 0.0037226ZM7.87213 1.40606C6.51292 1.42624 5.16232 1.88743 4.06413 2.70636C3.55821 3.08363 3.0846 3.55722 2.70648 4.06397C2.28581 4.62772 1.95745 5.26082 1.73222 5.94237C1.55233 6.48676 1.44989 7.03312 1.41425 7.63837C1.39905 7.89653 1.40618 8.30672 1.43082 8.59197C1.51986 9.62289 1.86226 10.6339 2.42457 11.5264C2.76886 12.0728 3.22065 12.5916 3.73453 13.0307C4.75789 13.9053 6.06675 14.4534 7.40813 14.5693C7.78652 14.602 8.21374 14.602 8.59213 14.5693C9.93334 14.4534 11.2425 13.9052 12.2657 13.0307C12.5338 12.8017 12.8019 12.5336 13.0309 12.2656C13.8513 11.3055 14.3854 10.0943 14.5434 8.83517C14.6006 8.37982 14.6095 7.88607 14.5692 7.40797C14.4624 6.14084 13.9543 4.87582 13.1527 3.88157C12.8893 3.55482 12.586 3.24287 12.2657 2.96918C11.2431 2.09531 9.93916 1.54878 8.59533 1.43079C8.38977 1.41274 8.09679 1.40272 7.87213 1.40606ZM7.87965 3.37325C7.73274 3.38743 7.58145 3.43072 7.44517 3.49758C7.09129 3.67116 6.84398 3.99026 6.76086 4.38055C6.73851 4.48549 6.7324 4.69502 6.74846 4.80637C6.8087 5.22436 7.06945 5.58309 7.44653 5.76676C7.79677 5.93736 8.20349 5.93736 8.55373 5.76676C8.92838 5.58427 9.19103 5.22462 9.25104 4.81195C9.26397 4.72297 9.26395 4.54692 9.251 4.45402C9.21497 4.19572 9.09763 3.95371 8.91469 3.76045C8.65096 3.48183 8.26202 3.33634 7.87965 3.37325ZM6.73893 6.74898C6.51919 6.78923 6.31386 6.95852 6.22708 7.17099C6.18735 7.26825 6.17925 7.31494 6.17985 7.44317C6.18032 7.54333 6.18218 7.56192 6.19748 7.61911C6.22842 7.73482 6.28308 7.83035 6.37066 7.92173C6.48369 8.03969 6.60746 8.10635 6.75907 8.13094C6.80535 8.13845 6.87461 8.14072 7.05773 8.14074L7.29613 8.14077V9.40453V10.6683L6.74093 10.6704C6.19184 10.6726 6.18519 10.6728 6.13693 10.6866C5.94878 10.7407 5.79228 10.8637 5.69869 11.0311C5.59588 11.2149 5.58619 11.4594 5.67386 11.6576C5.71277 11.7455 5.80762 11.8645 5.88813 11.9263C5.94313 11.9685 6.02053 12.0107 6.08156 12.0318C6.19988 12.0726 6.08407 12.0703 8.00013 12.0703C9.91619 12.0703 9.80038 12.0726 9.91869 12.0318C10.0569 11.984 10.1865 11.881 10.2737 11.7498C10.3341 11.6588 10.3666 11.5691 10.3812 11.4534C10.4049 11.2648 10.3497 11.0711 10.2319 10.9295C10.129 10.8059 10.0135 10.7298 9.86333 10.6866C9.81507 10.6728 9.80842 10.6726 9.25933 10.6704L8.70413 10.6683V9.04638C8.70413 7.89962 8.70204 7.40517 8.69701 7.35861C8.67892 7.19131 8.61901 7.06923 8.49333 6.9436C8.39197 6.84229 8.31923 6.79935 8.17613 6.75636C8.13197 6.74309 8.12177 6.74288 7.45933 6.74151C6.90973 6.74037 6.77851 6.74173 6.73893 6.74898ZM0.00341797 7.99997C0.00341797 8.13901 0.00388517 8.19588 0.00492197 8.12637C0.00595237 8.05685 0.00595237 7.94308 0.00492197 7.87357C0.00388517 7.80405 0.00341797 7.86093 0.00341797 7.99997Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_3123_59414",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AlertInformationCircle);


/***/ }),

/***/ 2721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var Link = function(param) {
    var _hasWrapper = param.hasWrapper, hasWrapper = _hasWrapper === void 0 ? true : _hasWrapper;
    if (hasWrapper) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "32",
                    height: "32",
                    rx: "16",
                    fill: "#DFE1E2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    clipPath: "url(#clip0_187_4288)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M19.5458 8.00944C19.1947 8.0585 18.8648 8.20877 18.5967 8.4418C18.5587 8.47482 17.9873 9.04759 17.3268 9.71463C16.6664 10.3817 15.8477 11.2082 15.5076 11.5514C15.0912 11.9715 14.8781 12.1911 14.8553 12.2234C14.7984 12.3041 14.7632 12.3831 14.7383 12.4858C14.725 12.5409 14.7269 12.7264 14.7414 12.7883C14.7857 12.9771 14.9043 13.1363 15.0787 13.2411C15.1368 13.276 15.1781 13.293 15.2546 13.3134C15.2983 13.3251 15.3236 13.3271 15.4274 13.3272C15.5407 13.3273 15.5533 13.3261 15.613 13.3096C15.6929 13.2875 15.7767 13.2463 15.844 13.196C15.8794 13.1695 16.4653 12.5823 17.7064 11.3294C18.7022 10.324 19.5315 9.49052 19.5492 9.47714C19.6175 9.42552 19.6965 9.40048 19.7922 9.40013C19.8869 9.39978 19.9553 9.41897 20.0248 9.46542C20.0495 9.48188 20.4235 9.85676 21.1084 10.5514C22.6644 12.1296 22.49 11.9488 22.524 12.0193C22.5565 12.0868 22.5666 12.1313 22.5666 12.2076C22.5666 12.2727 22.549 12.3435 22.5177 12.4046C22.4954 12.4481 22.3941 12.5508 20.656 14.2906C19.0524 15.8959 18.8135 16.1376 18.7826 16.185C18.7391 16.2519 18.7195 16.291 18.7024 16.345C18.6753 16.4307 18.6722 16.4546 18.6724 16.5754C18.6726 16.6755 18.6747 16.7018 18.6862 16.745C18.7065 16.8213 18.7236 16.8628 18.7585 16.9209C18.8634 17.0954 19.0225 17.2139 19.2114 17.2582C19.25 17.2673 19.2857 17.2697 19.373 17.2693C19.4731 17.2688 19.4918 17.267 19.549 17.2517C19.6244 17.2316 19.7003 17.1965 19.7686 17.1504C19.8071 17.1243 20.202 16.7332 21.5928 15.3439C22.5691 14.3686 23.4076 13.5283 23.4561 13.4765C23.5582 13.3675 23.6081 13.3053 23.6755 13.2026C23.7995 13.0141 23.8908 12.7922 23.9356 12.5709C23.964 12.4304 23.9712 12.3567 23.9712 12.2042C23.9712 12.0518 23.964 11.9781 23.9356 11.8375C23.8775 11.5505 23.7472 11.2775 23.5576 11.0453C23.5253 11.0058 23.297 10.7687 23.0501 10.5185C22.8032 10.2682 22.2652 9.72215 21.8545 9.30503C21.4438 8.88791 21.0739 8.51544 21.0324 8.47733C20.752 8.21971 20.4091 8.05847 20.0358 8.00876C19.9457 7.99676 19.6334 7.99719 19.5458 8.00944ZM18.1666 13.0562C18.0995 13.0626 18.0112 13.0863 17.9525 13.1136C17.8344 13.1685 17.9689 13.0373 15.5035 15.5027C13.0379 17.9682 13.1691 17.8337 13.1143 17.9517C13.0386 18.1149 13.0334 18.3373 13.1014 18.5071C13.1696 18.6773 13.3223 18.83 13.4926 18.8982C13.6623 18.9662 13.8847 18.961 14.0479 18.8853C14.1659 18.8305 14.0314 18.9617 16.4969 16.4962C18.9625 14.0306 18.8312 14.1651 18.886 14.0471C18.9615 13.8844 18.9668 13.6611 18.899 13.4918C18.8436 13.3535 18.7321 13.2256 18.5951 13.1433C18.4791 13.0737 18.3206 13.0414 18.1666 13.0562ZM12.5378 14.7295C12.4066 14.752 12.3215 14.7859 12.2242 14.8545C12.1919 14.8773 11.9722 15.0905 11.5522 15.5068C11.209 15.847 10.3824 16.6657 9.71538 17.3261C9.04834 17.9865 8.47557 18.558 8.44255 18.596C8.20667 18.8674 8.05682 19.199 8.00951 19.5542C7.99683 19.6494 7.99683 19.9399 8.00951 20.035C8.05773 20.3971 8.21085 20.7307 8.45672 21.0095C8.55327 21.1189 10.9877 23.5456 11.053 23.5975C11.3264 23.8146 11.6305 23.9456 11.9646 23.9901C12.0598 24.0028 12.3502 24.0028 12.4454 23.9901C12.8169 23.9406 13.1621 23.7791 13.4389 23.525C13.4787 23.4885 14.0387 22.9258 14.6833 22.2746C15.3279 21.6234 16.1391 20.8041 16.4861 20.4538C16.9475 19.9881 17.126 19.8038 17.1507 19.7678C17.1969 19.7004 17.2321 19.6243 17.2525 19.5482C17.2677 19.491 17.2696 19.4723 17.2701 19.3722C17.2705 19.285 17.268 19.2493 17.2589 19.2106C17.2146 19.0217 17.0961 18.8626 16.9216 18.7577C16.8636 18.7229 16.8223 18.7059 16.7458 18.6854C16.7021 18.6737 16.6768 18.6717 16.573 18.6716C16.4595 18.6715 16.4471 18.6727 16.3874 18.6893C16.3061 18.7119 16.2225 18.7529 16.1563 18.8027C16.1213 18.829 15.5146 19.4371 14.2918 20.6716C13.2949 21.678 12.4653 22.5116 12.4484 22.5241C12.3789 22.5751 12.3022 22.5986 12.205 22.5986C12.1264 22.5986 12.081 22.5883 12.013 22.5551C11.9661 22.5323 11.9357 22.5024 10.7164 21.2832C9.49722 20.064 9.46735 20.0335 9.4445 19.9866C9.41133 19.9186 9.40106 19.8732 9.40106 19.7946C9.40106 19.6958 9.42539 19.6179 9.47791 19.5484C9.49129 19.5307 10.3248 18.7014 11.3302 17.7056C12.5825 16.4651 13.1703 15.8786 13.1968 15.8432C13.247 15.776 13.2883 15.6922 13.3104 15.6122C13.3269 15.5526 13.3281 15.54 13.328 15.4266C13.3279 15.3229 13.3259 15.2975 13.3142 15.2538C13.2938 15.1774 13.2768 15.136 13.2419 15.078C13.1382 14.9055 12.9811 14.7875 12.7938 14.7415C12.7538 14.7316 12.5743 14.7233 12.5378 14.7295Z",
                        fill: "#3D4551"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_187_4288",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "16",
                            height: "16",
                            fill: "white",
                            transform: "translate(8 8)"
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_403_8651)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.5458 0.00943519C11.1947 0.0584976 10.8648 0.20877 10.5967 0.4418C10.5587 0.474818 9.98728 1.04759 9.32685 1.71463C8.6664 2.38167 7.84774 3.20823 7.50758 3.55143C7.09124 3.9715 6.87805 4.19112 6.85526 4.22343C6.79836 4.3041 6.76318 4.38305 6.73834 4.48583C6.72501 4.54093 6.72691 4.72638 6.74143 4.78826C6.78574 4.97713 6.90426 5.13626 7.07874 5.24113C7.13678 5.27601 7.17811 5.29301 7.25458 5.31345C7.29828 5.32512 7.32361 5.32714 7.42738 5.32723C7.5407 5.32732 7.55334 5.32613 7.61298 5.30962C7.69294 5.2875 7.77675 5.24629 7.84396 5.19604C7.87945 5.16951 8.46528 4.58234 9.70636 3.3294C10.7022 2.32405 11.5315 1.49052 11.5492 1.47714C11.6175 1.42552 11.6965 1.40048 11.7922 1.40013C11.8869 1.39978 11.9553 1.41897 12.0248 1.46542C12.0495 1.48188 12.4235 1.85676 13.1084 2.55139C14.6644 4.12964 14.49 3.9488 14.524 4.01933C14.5565 4.08678 14.5666 4.13127 14.5666 4.20759C14.5666 4.27274 14.549 4.34346 14.5177 4.40455C14.4954 4.44812 14.3941 4.55078 12.656 6.29063C11.0524 7.89592 10.8135 8.13757 10.7826 8.18503C10.7391 8.25189 10.7195 8.29103 10.7024 8.34503C10.6753 8.43074 10.6722 8.45459 10.6724 8.57543C10.6726 8.67551 10.6747 8.70175 10.6862 8.74503C10.7065 8.82134 10.7236 8.86276 10.7585 8.92087C10.8634 9.09536 11.0225 9.21388 11.2114 9.25819C11.25 9.26726 11.2857 9.26972 11.373 9.26931C11.4731 9.26884 11.4918 9.26697 11.549 9.2517C11.6244 9.23159 11.7003 9.19653 11.7686 9.15036C11.8071 9.1243 12.202 8.73324 13.5928 7.34387C14.5691 6.36859 15.4076 5.52826 15.4561 5.47646C15.5582 5.36753 15.6081 5.30529 15.6755 5.20263C15.7995 5.01407 15.8908 4.79223 15.9356 4.57094C15.964 4.43041 15.9712 4.35669 15.9712 4.20423C15.9712 4.05178 15.964 3.97806 15.9356 3.83752C15.8775 3.55055 15.7472 3.27749 15.5576 3.04533C15.5253 3.00583 15.297 2.76874 15.0501 2.51847C14.8032 2.2682 14.2652 1.72215 13.8545 1.30503C13.4438 0.887912 13.0739 0.515445 13.0324 0.477326C12.752 0.219714 12.4091 0.058472 12.0358 0.00875679C11.9457 -0.00324321 11.6334 -0.00280801 11.5458 0.00943519ZM10.1666 5.05617C10.0995 5.06259 10.0112 5.08627 9.9525 5.11356C9.83439 5.16848 9.96887 5.03729 7.50346 7.50271C5.03792 9.96824 5.16913 9.83374 5.11435 9.95175C5.0386 10.1149 5.03341 10.3373 5.10139 10.5071C5.16957 10.6773 5.32228 10.83 5.49256 10.8982C5.66232 10.9662 5.88471 10.961 6.04787 10.8853C6.16587 10.8305 6.03137 10.9617 8.49691 8.49615C10.9625 6.03062 10.8312 6.16512 10.886 6.04712C10.9615 5.88443 10.9668 5.66108 10.899 5.49181C10.8436 5.35347 10.7321 5.22559 10.5951 5.14333C10.4791 5.07367 10.3206 5.04143 10.1666 5.05617ZM4.53778 6.72951C4.40655 6.75196 4.3215 6.78586 4.22418 6.85451C4.19187 6.8773 3.97225 7.09049 3.55218 7.50683C3.20898 7.84699 2.38242 8.66565 1.71538 9.32609C1.04834 9.98653 0.47557 10.558 0.442552 10.596C0.206674 10.8674 0.056824 11.199 0.0095088 11.5542C-0.0031696 11.6494 -0.0031696 11.9399 0.0095088 12.035C0.0577264 12.3971 0.210846 12.7307 0.456715 13.0095C0.553266 13.1189 2.98765 15.5456 3.05298 15.5975C3.32635 15.8146 3.63046 15.9456 3.96457 15.9901C4.05975 16.0028 4.35021 16.0028 4.44539 15.9901C4.81694 15.9406 5.16205 15.7791 5.43894 15.525C5.47873 15.4885 6.03868 14.9258 6.68327 14.2746C7.32785 13.6234 8.13913 12.8041 8.48611 12.4538C8.94747 11.9881 9.12604 11.8038 9.15068 11.7678C9.19689 11.7004 9.23215 11.6243 9.25245 11.5482C9.26772 11.491 9.26959 11.4723 9.27006 11.3722C9.27047 11.285 9.26801 11.2493 9.25894 11.2106C9.21463 11.0217 9.09611 10.8626 8.92162 10.7577C8.86359 10.7229 8.82226 10.7059 8.74578 10.6854C8.70209 10.6737 8.67676 10.6717 8.57298 10.6716C8.45953 10.6715 8.4471 10.6727 8.38738 10.6893C8.30606 10.7119 8.22246 10.7529 8.15631 10.8027C8.1213 10.829 7.51458 11.4371 6.29181 12.6716C5.29488 13.678 4.46534 14.5116 4.44838 14.5241C4.37889 14.5751 4.30222 14.5986 4.20498 14.5986C4.12642 14.5986 4.08101 14.5883 4.01298 14.5551C3.96611 14.5323 3.93566 14.5024 2.71644 13.2832C1.49722 12.064 1.46735 12.0335 1.4445 11.9866C1.41133 11.9186 1.40106 11.8732 1.40106 11.7946C1.40106 11.6958 1.42539 11.6179 1.47791 11.5484C1.49129 11.5307 2.32482 10.7014 3.33019 9.70558C4.58253 8.46508 5.1703 7.87864 5.19681 7.84318C5.24704 7.776 5.28825 7.69217 5.31037 7.61223C5.32688 7.55259 5.32807 7.53995 5.32798 7.42663C5.3279 7.32286 5.32587 7.29752 5.3142 7.25383C5.29376 7.17736 5.27676 7.13603 5.24188 7.07799C5.1382 6.90548 4.98114 6.78753 4.79378 6.74148C4.75379 6.73165 4.57433 6.72326 4.53778 6.72951Z",
                    fill: "#3D4551"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_403_8651",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 83177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92563);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  & > span {\n    position: unset !important;\n    & .autoImage {\n      object-fit: contain !important;\n      position: relative !important;\n      height: auto !important;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var AutoHeightImage = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
            alt: "image",
            layout: "fill",
            className: "autoImage"
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AutoHeightImage);
var ImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-236e9c69-0"
})(_templateObject());


/***/ }),

/***/ 22701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ KAKAO_SHARE_TYPE; },
  "C": function() { return /* binding */ SelectModal_ShareSelectModal; }
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(81541);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(72282);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./src/components/atom/icon/Kakao.tsx

var KakaoIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "16",
                fill: "#FFE337"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.6719 10C14.7552 10 13.8906 10.1406 13.0781 10.4219C12.2656 10.7031 11.5573 11.0833 10.9531 11.5625C10.349 12.0417 9.86979 12.6042 9.51562 13.25C9.17188 13.8958 9 14.5833 9 15.3125C9 15.7812 9.07292 16.2344 9.21875 16.6719C9.36458 17.099 9.56771 17.5052 9.82812 17.8906C10.099 18.2656 10.4219 18.6146 10.7969 18.9375C11.1719 19.25 11.5833 19.526 12.0312 19.7656L11.5312 22.375L14.4219 20.5312C14.6198 20.5625 14.8229 20.5885 15.0312 20.6094C15.2396 20.6198 15.4531 20.625 15.6719 20.625C16.5885 20.625 17.4531 20.4896 18.2656 20.2188C19.0781 19.9375 19.7865 19.5573 20.3906 19.0781C20.9948 18.5885 21.4688 18.026 21.8125 17.3906C22.1667 16.7448 22.3438 16.0521 22.3438 15.3125C22.3438 14.5833 22.1667 13.8958 21.8125 13.25C21.4688 12.6042 20.9948 12.0417 20.3906 11.5625C19.7865 11.0833 19.0781 10.7031 18.2656 10.4219C17.4531 10.1406 16.5885 10 15.6719 10Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Kakao = (KakaoIcon);

// EXTERNAL MODULE: ./src/components/atom/icon/Link.tsx
var Link = __webpack_require__(2721);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/components/molecules/Modal/SelectModal/index.tsx
var SelectModal = __webpack_require__(73451);
;// CONCATENATED MODULE: ./src/components/molecules/Modal/SelectModal/ShareSelectModal/index.tsx










var KAKAO_SHARE_TYPE = {
    QNA: "QNA",
    MAGAZINE: "MAGAZINE",
    BOARD_POST: "BOARD_POST",
    NON_BENEFIT_MAP: "NON_BENEFIT_MAP"
};
/**
 * @param isVisible boolean
 * @param onClose () => void
 * @param type KAKAO_SHARE_TYPE
 * @param pageName string
 * @param kakaoShare [optional] KakaoShareProps
 * @param copyLink? CopyLinkProps
 */ var ShareSelectModal = function(param) {
    var isVisible = param.isVisible, onClose = param.onClose, type = param.type, pageName = param.pageName, kakaoShare = param.kakaoShare, copyLink = param.copyLink;
    var showToast = (0,useToast/* default */.Z)().showToast;
    var ref = (0,react.useState)(false), _isVisible = ref[0], _setIsVisible = ref[1];
    var ref1 = (0,react.useState)(), shareItems = ref1[0], setShareItems = ref1[1];
    var eventNamePath = type.toLocaleLowerCase();
    // 공유하기 [카카오]
    var onShareKakao = (0,react.useCallback)(function() {
        if (!window.Kakao.isInitialized()) {
            window.Kakao.init("b921b0231b604bf1aea6460c3d26cb57");
        }
        if (kakaoShare) {
            (0,logger/* mobileLogger */.Pp)({
                logger: {
                    eventName: "".concat(eventNamePath, "_share_kakao_click"),
                    pageName: pageName,
                    payload: {
                        id: kakaoShare.id
                    }
                }
            });
            var Kakao = window.Kakao;
            if (type === KAKAO_SHARE_TYPE.QNA) {
                Kakao.Share.sendCustom({
                    templateId: 90853,
                    templateArgs: {
                        questionPid: kakaoShare.id,
                        title: kakaoShare.title,
                        content: kakaoShare.content
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.MAGAZINE) {
                Kakao.Share.sendCustom({
                    templateId: 90880,
                    templateArgs: {
                        magazinePid: kakaoShare.id,
                        title: kakaoShare.title,
                        description: kakaoShare.content,
                        titleImageUrl: kakaoShare.imageUrl
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.BOARD_POST) {
                Kakao.Share.sendCustom({
                    templateId: 94245,
                    templateArgs: {
                        id: kakaoShare.id,
                        title: kakaoShare.title,
                        content: kakaoShare.content
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.NON_BENEFIT_MAP) {
                Kakao.Share.sendCustom({
                    templateId: 114723,
                    templateArgs: {
                        diagnosisTypeId: kakaoShare.id,
                        treatmentMedicineId: kakaoShare.subId,
                        title: kakaoShare.title,
                        description: kakaoShare.content,
                        thumbnailUrl: kakaoShare.imageUrl
                    }
                });
            }
        }
        onClose();
    }, [
        type,
        kakaoShare,
        eventNamePath,
        pageName,
        onClose
    ]);
    // 공유하기 [링크복사]
    var onCopyLink = (0,react.useCallback)(function() {
        if (copyLink) {
            var ref;
            (0,logger/* mobileLogger */.Pp)({
                logger: {
                    eventName: "".concat(eventNamePath, "_copy_link_click"),
                    pageName: pageName,
                    payload: {
                        id: copyLink === null || copyLink === void 0 ? void 0 : copyLink.id
                    }
                }
            });
            (ref = document.getElementById(copyLink === null || copyLink === void 0 ? void 0 : copyLink.copyElementId)) === null || ref === void 0 ? void 0 : ref.click();
        }
        onClose();
    }, [
        copyLink,
        eventNamePath,
        pageName,
        onClose
    ]);
    var onCompleteCopy = function() {
        showToast({
            message: "클립보드로 복사되었습니다."
        });
    };
    var generateSelectList = (0,react.useCallback)(function() {
        var selectItems = [];
        if (copyLink) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            hasWrapper: true
                        });
                    },
                    text: "링크 복사",
                    onClick: onCopyLink
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(selectItems));
        }
        if (kakaoShare) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Kakao, {});
                    },
                    text: "카카오톡으로 공유",
                    onClick: onShareKakao
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(selectItems));
        }
        setShareItems(selectItems);
    }, [
        copyLink,
        onShareKakao,
        onCopyLink,
        kakaoShare,
        setShareItems
    ]);
    (0,react.useEffect)(function() {
        generateSelectList();
    }, [
        generateSelectList
    ]);
    (0,react.useEffect)(function() {
        _setIsVisible(isVisible);
    }, [
        isVisible
    ]);
    // https://sharer.kakao.com/picker/link?app_key=b921b0231b604bf1aea6460c3d26cb57&short_key=7007dc80-2f45-494f-a8fc-3ad2b18dd522
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    defer: true,
                    src: "https://developers.kakao.com/sdk/js/kakao.min.js"
                })
            }),
            _isVisible && !!shareItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectModal/* default */.Z, {
                modalTitle: "공유하기",
                selectList: shareItems,
                onClose: onClose
            }),
            !!copyLink && /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                text: copyLink.copyLinkUrl,
                onCopy: onCompleteCopy,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    id: copyLink.copyElementId
                })
            })
        ]
    });
};
/* harmony default export */ var SelectModal_ShareSelectModal = (ShareSelectModal);


/***/ }),

/***/ 22909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98240);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react_simple_pull_to_refresh__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52560);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);
/* eslint-disable @typescript-eslint/no-explicit-any */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var PullToRefreshContainer = function(_param) {
    var children = _param.children, _pullingContent = _param.pullingContent, pullingContent = _pullingContent === void 0 ? "" : _pullingContent, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "pullingContent"
    ]);
    var _maxPullDownDistance, _maxPullDownDistance1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPullToRefresh, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        pullingContent: pullingContent,
        maxPullDownDistance: (_maxPullDownDistance = props.maxPullDownDistance) !== null && _maxPullDownDistance !== void 0 ? _maxPullDownDistance : 70,
        bottomPadding: (_maxPullDownDistance1 = props.maxPullDownDistance) !== null && _maxPullDownDistance1 !== void 0 ? _maxPullDownDistance1 : 70,
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PullToRefreshContainer);
var StyledPullToRefresh = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(react_simple_pull_to_refresh__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-690ab5c4-0"
})(_templateObject(), function(param) {
    var theme = param.theme, bottomPadding = param.bottomPadding;
    return "\n    padding-bottom: ".concat(bottomPadding, "px;\n    .lds-ellipsis {\n      width: 60px;\n      height: 60px;\n    }\n    \n    .lds-ellipsis div {\n      background: ").concat(theme.color.primary500, ";\n      width: 8px;\n      height: 8px;\n    }\n\n    .ptr__pull-down {\n      opacity: 0;\n    }\n    .ptr__loader {\n      display: none;\n    }\n  ");
});


/***/ }),

/***/ 31961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(22710);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/common/ConditionalHeaderRenderer.tsx
var ConditionalHeaderRenderer = __webpack_require__(48480);
// EXTERNAL MODULE: ./src/components/molecules/AppHeader/index.tsx + 3 modules
var AppHeader = __webpack_require__(93882);
// EXTERNAL MODULE: ./src/components/molecules/Modal/SelectModal/ReportSelectModal/index.tsx
var ReportSelectModal = __webpack_require__(28879);
// EXTERNAL MODULE: ./src/components/molecules/Modal/SelectModal/ShareSelectModal/index.tsx + 1 modules
var ShareSelectModal = __webpack_require__(22701);
// EXTERNAL MODULE: ./src/components/molecules/PullToRefresh/index.tsx
var PullToRefresh = __webpack_require__(22909);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Common/ReportTemplate/index.tsx
var ReportTemplate = __webpack_require__(53137);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/hooks/usePostReportModal.tsx + 3 modules
var usePostReportModal = __webpack_require__(53043);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./src/components/atom/buttons/DefaultButton.tsx
var DefaultButton = __webpack_require__(47641);
// EXTERNAL MODULE: ./src/components/molecules/AppContainer/index.tsx
var AppContainer = __webpack_require__(87733);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Community/PostDetailTemplate/DeletedPostItem.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100vh;\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 16px 0;\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 14px;\n  border-radius: 8px;\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var DeletedPostItem = function(param) {
    var title = param.title;
    var moveToPage = (0,useCustomRouter/* default */.Z)().moveToPage;
    var onClickList = function() {
        moveToPage({
            webLink: common/* ROUTES.COMMUNITY.LIST.path */.Z6.COMMUNITY.LIST.path,
            mobileScreenName: common/* ROUTES.COMMUNITY.LIST.appScreenName */.Z6.COMMUNITY.LIST.appScreenName
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHeader/* default */.Z, {
                title: title,
                onClickBackButton: RNPlugins/* historyBack */.$i
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: "신고로 인해 삭제 처리된 게시글입니다."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                        children: "많은 사용자의 신고로 인해 삭제된 게시글입니다."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        onClick: onClickList,
                        children: "목록으로 돌아가기"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PostDetailTemplate_DeletedPostItem = (DeletedPostItem);
var Container = (0,styled_components_browser_esm/* default */.ZP)(AppContainer/* default */.Z).withConfig({
    componentId: "sc-1bfed576-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray30, ";\n  ");
});
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1bfed576-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n  ");
});
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1bfed576-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI24SB, ";\n    color: ").concat(theme.color.gray800, ";\n  ");
});
var SubTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1bfed576-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.ARTICLE16R, ";\n    color: ").concat(theme.color.gray600, ";\n  ");
});
var Button = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-1bfed576-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray600, ";\n    background: ").concat(theme.color.gray20, ";\n    border: 1px solid ").concat(theme.color.gray100, ";\n\n    &:active {\n      background: ").concat(theme.color.gray50, ";\n    }\n  ");
});

// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Community/PostDetailTemplate/PostCommentInput.tsx + 1 modules
var PostCommentInput = __webpack_require__(7691);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
;// CONCATENATED MODULE: ./src/components/atom/icon/ArrowsSynchronize.tsx

function ArrowsSynchronize_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    ArrowsSynchronize_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArrowsSynchronize_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    ArrowsSynchronize_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ArrowsSynchronize_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 0.5s linear;\n"
    ]);
    ArrowsSynchronize_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var ArrowsSynchronize = function() {
    var ref = (0,react.useState)(false), rotation = ref[0], setRotation = ref[1];
    var onClick = function() {
        setRotation(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSVG, {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        rotation: rotation,
        onClick: onClick,
        onAnimationEnd: function() {
            return setRotation(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1184_27401)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M5.7816 0.425393C5.46162 0.444727 5.18927 0.484985 4.8936 0.556649C3.67498 0.852021 2.45338 1.64036 1.54254 2.7192C1.41442 2.87095 1.24631 3.08983 1.15601 3.22247L1.12383 3.26975L1.119 3.25127C1.11634 3.24111 1.09374 3.15149 1.06877 3.05213C1.01945 2.8559 1.00763 2.82337 0.959898 2.75264C0.867613 2.61588 0.695956 2.52484 0.530404 2.52484C0.291311 2.52484 0.0884103 2.67922 0.0162951 2.91602C0.00402151 2.95632 0.00313831 2.96512 0.00301351 3.048L0.00288391 3.1368L0.219969 4.0032C0.339364 4.47972 0.440423 4.88148 0.444541 4.896C0.455783 4.93564 0.48575 4.99681 0.514444 5.03869C0.582748 5.13839 0.693657 5.21525 0.818404 5.24936C0.861258 5.26108 0.874641 5.26249 0.943204 5.26259L1.02 5.2627L1.90449 5.04088C2.39095 4.91887 2.80251 4.81396 2.81905 4.80773C2.96384 4.75323 3.07669 4.63648 3.13113 4.48488C3.1866 4.33037 3.15498 4.1335 3.0529 3.99784C3.00444 3.93344 2.91595 3.86474 2.83745 3.83056C2.7575 3.79575 2.65684 3.78081 2.57539 3.79169C2.55173 3.79484 2.39948 3.83061 2.23705 3.87117C2.07463 3.91173 1.94126 3.94445 1.94069 3.94388C1.93879 3.94198 2.04016 3.79556 2.09901 3.7152C2.76381 2.8074 3.70646 2.0797 4.67914 1.72343C5.03956 1.59141 5.37862 1.51501 5.736 1.48527C5.85529 1.47535 6.12741 1.474 6.2592 1.48267C6.74255 1.5145 7.18288 1.6112 7.6272 1.78312C7.87749 1.87997 8.15723 2.0204 8.388 2.16507C8.87661 2.47136 9.30567 2.87147 9.64367 3.336C9.89157 3.6767 10.0706 4.01101 10.2291 4.42946C10.2753 4.55149 10.2915 4.58384 10.3348 4.64139C10.3992 4.72685 10.5045 4.79523 10.6211 4.82727C10.6626 4.83866 10.6769 4.84019 10.7448 4.84048C10.8272 4.84082 10.8572 4.83601 10.9257 4.81142C11.061 4.76281 11.1563 4.6778 11.2217 4.54729C11.2629 4.46516 11.2776 4.39424 11.2738 4.29558C11.2706 4.21152 11.2657 4.19211 11.2102 4.044C11.0038 3.49386 10.72 2.99147 10.3562 2.532C10.1471 2.26799 9.87644 1.98658 9.6216 1.76826C8.70459 0.982634 7.58466 0.523049 6.3696 0.43374C6.27799 0.427005 5.85441 0.420991 5.7816 0.425393ZM10.9848 6.73892C10.9401 6.74635 9.21124 7.18086 9.18093 7.19227C9.03617 7.24676 8.92331 7.36352 8.86888 7.51512C8.81329 7.66993 8.84482 7.86622 8.94711 8.00215C8.99557 8.06655 9.08406 8.13526 9.16256 8.16944C9.24252 8.20425 9.34317 8.21918 9.42465 8.2083C9.44832 8.20515 9.60921 8.16722 9.78219 8.12402C9.95516 8.08082 10.0975 8.04627 10.0985 8.04725C10.1029 8.05168 9.98205 8.23785 9.89657 8.35828C9.64582 8.71157 9.33078 9.05285 9.0024 9.32693C8.16501 10.0259 7.15512 10.4363 6.06851 10.5193C5.90846 10.5316 5.64467 10.5181 5.4 10.4852C4.12044 10.3133 2.97937 9.60776 2.2542 8.54026C2.05718 8.25024 1.90787 7.96339 1.77141 7.61274C1.72379 7.49037 1.71691 7.47575 1.6833 7.4256C1.61596 7.32511 1.50652 7.24979 1.3752 7.21357C1.34251 7.20455 1.32432 7.20295 1.2528 7.20283C1.15888 7.20266 1.12569 7.20877 1.04757 7.24062C0.883487 7.30752 0.763852 7.45763 0.72933 7.63994C0.720532 7.68639 0.725893 7.80299 0.739098 7.85241C0.774503 7.9849 0.939047 8.36573 1.05968 8.5944C1.45881 9.35092 2.02308 10.0053 2.70461 10.5019C3.28601 10.9255 3.92114 11.2259 4.61303 11.4043C5.13288 11.5384 5.73781 11.602 6.1704 11.5682C7.38935 11.4728 8.54579 11.0236 9.51117 10.2705C10.0253 9.86941 10.46 9.4039 10.8412 8.84623L10.8882 8.77758L10.9324 8.95302C10.9804 9.14366 10.9926 9.17698 11.0402 9.2476C11.1454 9.40359 11.35 9.49573 11.5354 9.47056C11.7533 9.44098 11.9183 9.29866 11.9837 9.08397C11.996 9.04368 11.9969 9.03487 11.997 8.952L11.9971 8.8632L11.78 7.9968C11.6606 7.52028 11.5596 7.11852 11.5555 7.104C11.5442 7.06435 11.5143 7.00318 11.4856 6.96131C11.417 6.86123 11.3044 6.7834 11.1816 6.75116C11.1292 6.7374 11.0307 6.73127 10.9848 6.73892Z",
                    fill: "#A9AEB1"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1184_27401",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icon_ArrowsSynchronize = (ArrowsSynchronize);
var StyledSVG = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-5901ef7a-0"
})(ArrowsSynchronize_templateObject(), function(param) {
    var rotation = param.rotation;
    return rotation && rotateAnimation;
});
var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(ArrowsSynchronize_templateObject1());
var rotateAnimation = (0,styled_components_browser_esm/* css */.iv)(ArrowsSynchronize_templateObject2(), rotate);

// EXTERNAL MODULE: ./src/hooks/useAuthModal.tsx
var useAuthModal = __webpack_require__(71213);
// EXTERNAL MODULE: ./src/recoil/atoms/common/auth.ts
var auth = __webpack_require__(4415);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Community/PostDetailTemplate/PostComments/PostCommentItem.tsx
var PostCommentItem = __webpack_require__(2744);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Community/PostDetailTemplate/PostComments/PostMultipleComment.tsx

function PostMultipleComment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 1px;\n  margin: 8px 24px;\n\n  ",
        ";\n"
    ]);
    PostMultipleComment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var PostMultipleComment = function(param) {
    var comments = param.comments, onShowReportModal = param.onShowReportModal, setLikeCommentStatus = param.setLikeCommentStatus, isAdmin = param.isAdmin;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: comments.map(function(comment, key) {
            var isReplyComment = comment.boardCommentPid !== comment.parentBoardCommentPid;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                        isVisible: !isReplyComment && !!key
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCommentItem/* default */.Z, {
                        comment: comment,
                        isReplyComment: isReplyComment,
                        setLikeCommentStatus: setLikeCommentStatus,
                        onShowReportModal: onShowReportModal,
                        isAdmin: isAdmin
                    })
                ]
            }, "comment_".concat(comment.parentBoardCommentPid));
        })
    });
};
/* harmony default export */ var PostComments_PostMultipleComment = (PostMultipleComment);
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97f797bb-0"
})(PostMultipleComment_templateObject(), function(param) {
    var theme = param.theme, isVisible = param.isVisible;
    return "\n    background: ".concat(theme.color.gray50, ";\n    display: ").concat(isVisible ? "block" : "none", ";\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Community/PostDetailTemplate/PostComments/index.tsx

function PostComments_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 32px;\n  ",
        ";\n"
    ]);
    PostComments_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PostComments_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px 8px;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    PostComments_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PostComments_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  ",
        ";\n"
    ]);
    PostComments_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PostComments_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 3px 8px;\n  margin-left: 8px;\n  border-radius: 4px;\n\n  ",
        ";\n"
    ]);
    PostComments_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PostComments_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  svg {\n    margin-right: 6px;\n  }\n\n  ",
        ";\n"
    ]);
    PostComments_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 16px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}









var PostComments = function(param) {
    var commentsRef = param.commentsRef, boardPostDetail = param.boardPostDetail, refreshPost = param.refreshPost, setLikeCommentStatus = param.setLikeCommentStatus, userProfile = param.userProfile;
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var setShowAuthModal = (0,useAuthModal/* default */.Z)().setShowAuthModal;
    var ref = (0,usePostReportModal/* default */.ZP)(), showReportModal = ref.showReportModal, onShowReportModal = ref.onShowReportModal, onCloseReportModal = ref.onCloseReportModal, reportData = ref.reportData, reportItems = ref.reportItems;
    var onClickRefresh = function() {
        refreshPost();
    };
    // 질문 신고하기
    var onShowModal = function(e, data) {
        e.stopPropagation();
        if (!token) return setShowAuthModal(true);
        onShowReportModal(data);
    };
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostComments_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostComments_Title, {
                        children: [
                            "댓글",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommentCount, {
                                children: [
                                    boardPostDetail.boardCommentCount,
                                    "개"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Refresh, {
                        onClick: onClickRefresh,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_ArrowsSynchronize, {}),
                            "새로고침"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Comments, {
                ref: commentsRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostComments_PostMultipleComment, {
                    comments: boardPostDetail.boardComments,
                    setLikeCommentStatus: setLikeCommentStatus,
                    onShowReportModal: onShowModal,
                    isAdmin: (ref1 = userProfile === null || userProfile === void 0 ? void 0 : userProfile.isAdmin) !== null && ref1 !== void 0 ? ref1 : false
                })
            }),
            reportItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportSelectModal/* default */.Z, {
                isVisible: showReportModal,
                onClose: onCloseReportModal,
                selectList: reportItems,
                title: (reportData === null || reportData === void 0 ? void 0 : reportData.isAdmin) ? "관리하기" : (reportData === null || reportData === void 0 ? void 0 : reportData.isMine) ? "댓글 관리" : "신고하기"
            })
        ]
    });
};
/* harmony default export */ var PostDetailTemplate_PostComments = (PostComments);
var PostComments_Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b4daef7a-0"
})(PostComments_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n  ");
});
var TitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4daef7a-1"
})(PostComments_templateObject1());
var PostComments_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4daef7a-2"
})(PostComments_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI18B, ";\n    color: ").concat(theme.color.gray800, ";\n  ");
});
var CommentCount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4daef7a-3"
})(PostComments_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI12M, ";\n    color: ").concat(theme.color.blue500, ";\n    background: ").concat(theme.color.blue100, ";\n  ");
});
var Refresh = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4daef7a-4"
})(PostComments_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray300, ";\n  ");
});
var Comments = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-b4daef7a-5"
})(_templateObject5());

// EXTERNAL MODULE: ./src/components/atom/icon/AlertInformationCircle.tsx
var AlertInformationCircle = __webpack_require__(4794);
// EXTERNAL MODULE: ./src/components/atom/icon/DotMenu.tsx
var DotMenu = __webpack_require__(48537);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/components/atom/icon/EditViewOff.tsx


var EditViewOff = function(param) {
    var _size = param.size, size = _size === void 0 ? 24 : _size, _color = param.color, color = _color === void 0 ? theme/* default.color.red600 */.Z.color.red600 : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_2512_42777)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0.860451 0.0144651C0.638269 0.0564171 0.455447 0.157275 0.291555 0.328299C0.160496 0.46506 0.0783202 0.609214 0.0307426 0.785806C0.00830738 0.869067 0.00585938 0.89515 0.00585938 1.05095C0.00585938 1.20758 0.00824978 1.23273 0.0313954 1.31975C0.0618562 1.43424 0.132867 1.58229 0.201786 1.67495C0.268419 1.76454 22.235 23.7311 22.3246 23.7977C22.4172 23.8666 22.5653 23.9377 22.6798 23.9681C22.7668 23.9913 22.7919 23.9937 22.9486 23.9937C23.1056 23.9937 23.13 23.9913 23.2167 23.968C23.5766 23.8712 23.8713 23.5757 23.9688 23.2137C23.9912 23.1304 23.9937 23.1043 23.9937 22.9485C23.9937 22.7919 23.9913 22.7668 23.9681 22.6797C23.9377 22.5652 23.8666 22.4171 23.7977 22.3245C23.7693 22.2865 22.7864 21.2956 21.5306 20.0389L19.3135 17.8205L19.4126 17.7448C20.7161 16.7486 22.1562 15.342 23.2846 13.9629C24.1859 12.8615 24.2145 11.2565 23.353 10.123C23.2392 9.9732 22.8446 9.51165 22.5611 9.19675C21.3553 7.85739 20.0857 6.71191 18.8067 5.80956C16.7861 4.38392 14.795 3.58497 12.811 3.40372C12.4071 3.36682 11.7652 3.35984 11.3806 3.38816C10.3234 3.46599 9.30911 3.70217 8.27496 4.11132C7.7079 4.33566 7.23309 4.56253 6.63886 4.89303L6.47636 4.98341L4.10925 2.61763C2.76484 1.27396 1.71313 0.230235 1.67496 0.201819C1.58127 0.132065 1.43357 0.0615147 1.31976 0.0321483C1.19758 0.000621866 0.978445 -0.00781654 0.860451 0.0144651ZM11.8174 5.47822C10.8067 5.50254 9.73633 5.75944 8.65416 6.23744C8.4525 6.32651 8.03496 6.52816 8.03496 6.53647C8.03496 6.53961 8.41189 6.91877 8.87256 7.37902L9.71016 8.21585L9.79176 8.16807C10.148 7.95946 10.6086 7.77965 11.0289 7.68515C11.6513 7.5452 12.3482 7.5452 12.9706 7.68515C14.0706 7.9325 15.0421 8.59884 15.6726 9.53838C16.3032 10.4782 16.5479 11.625 16.3578 12.7498C16.2739 13.2459 16.0798 13.7836 15.8314 14.2077L15.7837 14.2893L16.7933 15.2998C17.3486 15.8556 17.8082 16.3083 17.8147 16.3058C17.8327 16.299 18.1581 16.0527 18.3406 15.9078C19.4295 15.0431 20.5092 13.9847 21.5095 12.8013C21.7001 12.5759 21.7237 12.5431 21.7765 12.4305C21.8373 12.3008 21.8596 12.204 21.8657 12.0429C21.8732 11.8419 21.8443 11.7011 21.7611 11.5341C21.7179 11.4474 21.7196 11.4496 21.4708 11.1549C20.7459 10.2967 19.8681 9.39969 19.0606 8.69216C17.3667 7.20804 15.6403 6.20527 14.0062 5.75644C13.5626 5.63461 13.0854 5.54627 12.6526 5.50588C12.4733 5.48914 12.0984 5.47105 11.9902 5.4739C11.9506 5.47494 11.8728 5.47688 11.8174 5.47822ZM3.65409 7.23908C3.49435 7.26243 3.32832 7.33248 3.19507 7.43278C3.03092 7.55632 2.19741 8.37448 1.7992 8.80295C1.22338 9.42251 0.688947 10.0466 0.533168 10.2813C-0.19431 11.3776 -0.143757 12.8566 0.656538 13.8909C0.770039 14.0376 1.21308 14.554 1.46326 14.8312C3.04589 16.5846 4.73855 18.0013 6.42216 18.9819C7.99221 19.8963 9.54621 20.4307 11.0878 20.5864C11.484 20.6264 12.0733 20.6416 12.439 20.6214C12.9605 20.5925 13.47 20.526 13.9486 20.4246C14.3512 20.3392 14.8439 20.205 14.9724 20.1456C15.2701 20.008 15.4942 19.7212 15.5614 19.3917C15.6185 19.1115 15.5451 18.7937 15.3683 18.5552C15.1944 18.3205 14.8899 18.1574 14.5893 18.138C14.4631 18.1299 14.3605 18.1437 14.1867 18.1923C13.8057 18.2988 13.5112 18.3678 13.2286 18.4166C11.7985 18.6637 10.3809 18.4811 8.87496 17.8558C7.37167 17.2315 5.82489 16.1729 4.30093 14.7251C4.0737 14.5092 3.55663 13.9879 3.33559 13.7517C3.03195 13.4274 2.52746 12.8528 2.31104 12.5848C2.26878 12.5325 2.20744 12.412 2.17982 12.3271C2.14053 12.2062 2.12846 12.1107 2.1336 11.9613C2.13932 11.7956 2.16068 11.7019 2.22306 11.569C2.27454 11.4592 2.29773 11.4265 2.46425 11.2289C3.09553 10.4796 3.68737 9.85472 4.44618 9.13626C4.53417 9.05295 4.62996 8.95359 4.65904 8.91546C4.7633 8.77878 4.83276 8.61482 4.85743 8.4471C4.87583 8.32202 4.86558 8.12046 4.83484 8.00315C4.74972 7.67823 4.47832 7.39066 4.15405 7.28181C4.01465 7.23502 3.80471 7.21708 3.65409 7.23908ZM11.8174 9.6918C11.6543 9.71072 11.5336 9.73144 11.4244 9.75926C11.3535 9.77732 11.2942 9.79328 11.2928 9.79473C11.2913 9.79617 11.946 10.4531 12.7475 11.2547L14.2048 12.712L14.2345 12.5983C14.2964 12.3609 14.3188 12.1609 14.3102 11.9229C14.2976 11.5746 14.2255 11.287 14.0733 10.9773C13.9506 10.7277 13.8395 10.5738 13.6326 10.367C13.4257 10.1601 13.2718 10.0489 13.0222 9.92623C12.7967 9.81536 12.5817 9.74764 12.3358 9.70999C12.2402 9.69536 11.892 9.68314 11.8174 9.6918Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2512_42777",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icon_EditViewOff = (EditViewOff);

// EXTERNAL MODULE: ./src/components/atom/icon/FavoriteHeart.tsx
var FavoriteHeart = __webpack_require__(17042);
// EXTERNAL MODULE: ./src/components/atom/icon/Share.tsx
var Share = __webpack_require__(13531);
// EXTERNAL MODULE: ./src/components/atom/images/AutoHeightImage.tsx
var AutoHeightImage = __webpack_require__(83177);
// EXTERNAL MODULE: ./src/components/molecules/CommunityUserNickName.tsx + 1 modules
var CommunityUserNickName = __webpack_require__(36221);
// EXTERNAL MODULE: ./src/components/molecules/ProfileImage/index.tsx
var ProfileImage = __webpack_require__(66039);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/utils/image.ts
var utils_image = __webpack_require__(60288);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Community/PostDetailTemplate/PostContent.tsx

function PostContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 12px;\n\n  ",
        "\n"
    ]);
    PostContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PostContent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n"
    ]);
    PostContent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PostContent_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 16px;\n\n  ",
        "\n"
    ]);
    PostContent_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PostContent_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 24px;\n  white-space: break-spaces;\n\n  ",
        ";\n"
    ]);
    PostContent_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PostContent_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 24px;\n"
    ]);
    PostContent_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PostContent_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  border-radius: 8px;\n"
    ]);
    PostContent_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 16px;\n\n  svg {\n    margin-right: 8px;\n  }\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 24px 0;\n  align-items: center;\n\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 16px;\n  border-radius: 8px;\n\n  ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  display: flex;\n  margin-left: 12px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px;\n  border-radius: 6px;\n  ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  align-items: center;\n  padding: 18px 0;\n\n  ",
        ";\n\n  &:not(first-child) {\n    border-left: none;\n  }\n\n  svg {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}















var PostContent = function(param) {
    var boardPostDetail = param.boardPostDetail, updateLikePostStatus = param.updateLikePostStatus, onReport = param.onReport, onShowShareModal = param.onShowShareModal;
    var ref = (0,react.useState)(null), isVisibleImage = ref[0], setIsVisibleImage = ref[1];
    var profileImage = (0,react.useMemo)(function() {
        return boardPostDetail.communityUser.profileImageUrl;
    }, []);
    var onChangeViewSecretImage = function() {
        setIsVisibleImage(true);
    };
    (0,react.useEffect)(function() {
        if (boardPostDetail.isMine) return setIsVisibleImage(true);
        if (boardPostDetail.boardPostAttachments.length) {
            var isBlindImage = boardPostDetail.boardPostAttachments[0].blindType === gql_schema/* AttachmentBlindType.Blinded */.jzP.Blinded;
            return setIsVisibleImage(!isBlindImage);
        }
    }, [
        boardPostDetail.isMine,
        boardPostDetail.boardPostAttachments.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostContent_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Top, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostContent_Title, {
                        children: boardPostDetail.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                        children: boardPostDetail.content
                    }),
                    isVisibleImage !== null && !!boardPostDetail.boardPostAttachments.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                                children: isVisibleImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoHeightImage/* default */.Z, {
                                    src: (0,utils_image/* redirectPostImage */.R2)(boardPostDetail.boardPostAttachments[0].boardPostAttachmentId)
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecretImage, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_EditViewOff, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: "숨겨진 이미지"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: "주의가 필요한 내용일 수 있어요."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecretImageViewButton, {
                                            onClick: onChangeViewSecretImage,
                                            children: "이미지 보기"
                                        })
                                    ]
                                })
                            }),
                            boardPostDetail.isMine && boardPostDetail.boardPostAttachments[0].blindType === gql_schema/* AttachmentBlindType.Blinded */.jzP.Blinded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecretImageInfo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertInformationCircle/* default */.Z, {}),
                                    " 이미지가 숨김 처리되었어요."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserInfo, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileInfo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileImage/* default */.Z, {
                                        width: 32,
                                        height: 32,
                                        src: profileImage
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Author, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityUserNickName/* default */.Z, {
                                                userId: boardPostDetail.communityUser.userId,
                                                nickName: boardPostDetail.communityUser.nickname
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostContent_Date, {
                                                children: boardPostDetail.formattedCreatedAt
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AsideIcon, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                    onClick: function(e) {
                                        return onReport(e);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DotMenu/* default */.Z, {})
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bottom, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomButton, {
                        active: boardPostDetail.isLikedByMe,
                        onClick: function() {
                            return updateLikePostStatus(!boardPostDetail.isLikedByMe);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteHeart/* default */.Z, {
                                color: theme/* default.color.gray400 */.Z.color.gray400,
                                isActive: boardPostDetail.isLikedByMe
                            }),
                            "공감해요 ",
                            boardPostDetail.likeCount ? boardPostDetail.likeCount : ""
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomButton, {
                        onClick: onShowShareModal,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Share/* default */.Z, {
                                color: theme/* default.color.gray400 */.Z.color.gray400
                            }),
                            "공유하기"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PostDetailTemplate_PostContent = (PostContent);
var PostContent_Container = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-60f75b-0"
})(PostContent_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n  ");
});
var Top = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60f75b-1"
})(PostContent_templateObject1());
var PostContent_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-60f75b-2"
})(PostContent_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI24SB, ";\n    color: ").concat(theme.color.gray800, ";\n  ");
});
var Content = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-60f75b-3"
})(PostContent_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.ARTICLE16R, ";\n    color: ").concat(theme.color.gray600, ";\n  ");
});
var ImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60f75b-4"
})(PostContent_templateObject4());
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60f75b-5"
})(PostContent_templateObject5());
var SecretImageInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60f75b-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.blue500, ";\n  ");
});
var SecretImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60f75b-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.red100, ";\n\n    svg {\n      margin-bottom: 8px;\n    }\n    h2 {\n      ").concat(theme.typography.UI16SB, ";\n      color: ").concat(theme.color.gray700, ";\n      margin-bottom: 4px;\n    }\n    h3 {\n      ").concat(theme.typography.UI14M, ";\n      color: ").concat(theme.color.gray500, ";\n      margin-bottom: 16px;\n    }\n  ");
});
var SecretImageViewButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-60f75b-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray600, ";\n    background: ").concat(theme.color.white, ";\n    border: 1px solid ").concat(theme.color.gray100, ";\n\n    &: active {\n      background: ").concat(theme.color.gray50, ";\n    }\n  ");
});
var UserInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60f75b-9"
})(_templateObject9());
var ProfileInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60f75b-10"
})(_templateObject10());
var Author = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60f75b-11"
})(_templateObject11());
var PostContent_Date = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-60f75b-12"
})(_templateObject12(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI12R, ";\n    color: ").concat(theme.color.gray300, ";\n  ");
});
var AsideIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60f75b-13"
})(_templateObject13());
var Icon = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-60f75b-14"
})(_templateObject14(), function(param) {
    var theme = param.theme;
    return "\n    &: active {\n      background: ".concat(theme.color.gray50, "\n    }\n  ");
});
var Bottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60f75b-15"
})(_templateObject15());
var BottomButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-60f75b-16"
})(_templateObject16(), function(param) {
    var theme = param.theme, active = param.active;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(active ? theme.color.primary500 : theme.color.gray400, ";\n    border: 1px solid ").concat(theme.color.gray50, ";\n\n    &: active {\n      background: ").concat(theme.color.gray50, ";\n    }\n  ");
});

// EXTERNAL MODULE: ./src/components/atom/Skeleton/index.tsx + 1 modules
var Skeleton = __webpack_require__(13971);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Community/PostDetailTemplate/PostDetailSkeleton.tsx

function PostDetailSkeleton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  ",
        ";\n"
    ]);
    PostDetailSkeleton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PostDetailSkeleton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    PostDetailSkeleton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PostDetailSkeleton_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    PostDetailSkeleton_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PostDetailSkeleton_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  ",
        ";\n"
    ]);
    PostDetailSkeleton_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PostDetailSkeleton_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PostDetailSkeleton_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PostDetailSkeleton_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 36px;\n"
    ]);
    PostDetailSkeleton_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PostDetailSkeleton_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PostDetailSkeleton_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function PostDetailSkeleton_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  ",
        ";\n"
    ]);
    PostDetailSkeleton_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function PostDetailSkeleton_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  align-items: center;\n  padding: 18px 0;\n\n  ",
        ";\n\n  & > div {\n    margin: auto;\n  }\n  &:not(first-child) {\n    border-left: none;\n  }\n"
    ]);
    PostDetailSkeleton_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function PostDetailSkeleton_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  margin-top: 12px;\n"
    ]);
    PostDetailSkeleton_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function PostDetailSkeleton_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 32px 24px 8px;\n"
    ]);
    PostDetailSkeleton_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function PostDetailSkeleton_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 20px;\n  border-radius: 10px;\n  margin-bottom: 15px;\n"
    ]);
    PostDetailSkeleton_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}





var PostDetailComment = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Comment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            style: {
                                width: 32,
                                height: 32,
                                borderRadius: "50%",
                                marginRight: 12
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: 40,
                                    height: 16,
                                    marginBottom: 4
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: 50,
                                    height: 16
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                style: {
                    height: 22,
                    margin: "16px 0 0 44px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                style: {
                    height: 22,
                    margin: "8px 0 16px 44px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: 50,
                            height: 18,
                            marginLeft: 44
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: 50,
                            height: 18,
                            marginLeft: 16
                        }
                    })
                ]
            })
        ]
    });
};
var PostDetailSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostDetailSkeleton_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHeader/* default */.Z, {
                onClickBackButton: function() {
                    return null;
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailTop, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    height: 32,
                                    marginBottom: 8
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: "90%",
                                    height: 22,
                                    marginBottom: 4
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: "80%",
                                    height: 22,
                                    marginBottom: 4
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: "80%",
                                    height: 22,
                                    marginBottom: 20
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    height: 200,
                                    marginTop: 20,
                                    marginBottom: 24
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    style: {
                                        width: 32,
                                        height: 32,
                                        borderRadius: "50%",
                                        marginRight: 12
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        style: {
                                            width: 40,
                                            height: 16,
                                            marginBottom: 4
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        style: {
                                            width: 50,
                                            height: 16
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetailSkeleton_BottomButton, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            style: {
                                width: 80,
                                height: 22
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetailSkeleton_BottomButton, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            style: {
                                width: 80,
                                height: 22
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommentTitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: 40,
                                    height: 22
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: 40,
                                    height: 22,
                                    marginLeft: 8
                                }
                            })
                        ]
                    }),
                    Array.from({
                        length: 4
                    }).map(function(_, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetailComment, {}, "skeleton_".concat(i));
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PostDetailTemplate_PostDetailSkeleton = (PostDetailSkeleton);
var PostDetailSkeleton_Container = (0,styled_components_browser_esm/* default */.ZP)(AppContainer/* default */.Z).withConfig({
    componentId: "sc-18943dc7-0"
})(PostDetailSkeleton_templateObject(), function(param) {
    var theme = param.theme;
    return "background: ".concat(theme.color.gray40);
});
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18943dc7-1"
})(PostDetailSkeleton_templateObject1());
var Column = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18943dc7-2"
})(PostDetailSkeleton_templateObject2());
var DetailWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18943dc7-3"
})(PostDetailSkeleton_templateObject3(), function(param) {
    var theme = param.theme;
    return "background: ".concat(theme.color.white);
});
var DetailTop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18943dc7-4"
})(PostDetailSkeleton_templateObject4());
var ProfileWrapper = (0,styled_components_browser_esm/* default */.ZP)(Row).withConfig({
    componentId: "sc-18943dc7-5"
})(PostDetailSkeleton_templateObject5());
var Profile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18943dc7-6"
})(PostDetailSkeleton_templateObject6());
var ButtonRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18943dc7-7"
})(PostDetailSkeleton_templateObject7(), function(param) {
    var theme = param.theme;
    return "background: ".concat(theme.color.white);
});
var PostDetailSkeleton_BottomButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18943dc7-8"
})(PostDetailSkeleton_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    border: 1px solid ".concat(theme.color.gray50, ";\n  ");
});
var CommentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18943dc7-9"
})(PostDetailSkeleton_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
});
var CommentTitle = (0,styled_components_browser_esm/* default */.ZP)(Row).withConfig({
    componentId: "sc-18943dc7-10"
})(PostDetailSkeleton_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.color.white;
});
var Comment = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18943dc7-11"
})(PostDetailSkeleton_templateObject11(), function(param) {
    var theme = param.theme;
    return theme.color.white;
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(85244);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./src/hooks/auth/useSetAuthOnScreenFocus.tsx
var useSetAuthOnScreenFocus = __webpack_require__(95392);
// EXTERNAL MODULE: ./src/hooks/community/mobile/community.gql.impl.tsx
var community_gql_impl = __webpack_require__(42549);
;// CONCATENATED MODULE: ./src/hooks/community/mobile/useGetBoardPostByPostDetail.tsx

var useGetBoardPostByPostDetail = function(boardPostPid) {
    var ref = (0,community_gql_impl/* useGetBoardPostQuery */.QQ)({
        boardPostPid: boardPostPid
    }, {
        enabled: !!boardPostPid,
        refetchOnWindowFocus: true,
        select: parseBoardPostDetail
    }), data = ref.data, isLoading = ref.isLoading, refetch = ref.refetch;
    return {
        data: data,
        isLoading: isLoading,
        refetch: refetch
    };
};
/* harmony default export */ var mobile_useGetBoardPostByPostDetail = (useGetBoardPostByPostDetail);
var parseBoardPostDetail = function(param) {
    var _boardPost = param.boardPost, boardPostPid = _boardPost.boardPostPid, boardCategoryId = _boardPost.boardCategoryId, title = _boardPost.title, content = _boardPost.content, likeCount = _boardPost.likeCount, boardCommentCount = _boardPost.boardCommentCount, createdAt = _boardPost.createdAt, isLikedByMe = _boardPost.isLikedByMe, isMine = _boardPost.isMine, blinded = _boardPost.blinded, boardPostAttachments = _boardPost.boardPostAttachments, communityUser = _boardPost.communityUser, boardCategory = _boardPost.boardCategory, boardComments = _boardPost.boardComments;
    return {
        boardPostPid: boardPostPid,
        boardCategoryId: boardCategoryId,
        title: title,
        content: content,
        likeCount: likeCount,
        boardCommentCount: boardCommentCount,
        createdAt: createdAt,
        isLikedByMe: isLikedByMe,
        isMine: isMine,
        blinded: blinded,
        boardPostAttachments: boardPostAttachments,
        communityUser: communityUser,
        boardCategory: boardCategory,
        boardComments: boardComments
    };
};

// EXTERNAL MODULE: ./src/services/community/index.tsx
var community = __webpack_require__(29178);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(95210);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
;// CONCATENATED MODULE: ./src/services/community/BoardPostDetailService.ts




var BoardPostDetailService = function BoardPostDetailService() {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, BoardPostDetailService);
};
BoardPostDetailService.boardPostDetailParser = function(data) {
    if (!data) return {};
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        formattedCreatedAt: (0,format/* displayedAt */.hX)(data.createdAt),
        boardComments: data.boardComments.map(function(comment) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, comment), {
                formattedCreatedAt: (0,format/* displayedAt */.hX)(comment.createdAt)
            });
        })
    });
};

// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Community/PostDetailTemplate/useBoardPostDetailViewModel.tsx

















var COMMENT_MAX_LENGTH = 1000;
var useBoardPostDetailViewModel = function(param) {
    var boardPostPid = param.boardPostPid;
    (0,useSetAuthOnScreenFocus/* default */.Z)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var setShowAuthModal = (0,useAuthModal/* default */.Z)().setShowAuthModal;
    var pageName = (0,useCustomRouter/* default */.Z)().pageName;
    var ref = (0,react.useState)(""), comment = ref[0], setComment = ref[1];
    var ref1 = (0,react.useState)(false), addCommentLoading = ref1[0], setAddCommentLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isShareModalOpen = ref2[0], setIsShareModalOpen = ref2[1];
    var isLoggedIn = !!token;
    // 상세페이지 가져오기
    var ref3 = mobile_useGetBoardPostByPostDetail(boardPostPid), data = ref3.data, isBoardPostDetailLoading = ref3.isLoading, refetchBoardPostDetail = ref3.refetch;
    var boardPostDetail = BoardPostDetailService.boardPostDetailParser(data);
    var boardPostRefresh = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            refetchBoardPostDetail()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function boardPostRefresh() {
            return _ref.apply(this, arguments);
        };
    }();
    // TODO: 추후 마이페이지 관련 viewModel 추가되면 변경할예정
    // 유저 정보 가져오기
    var ref4 = (0,community_gql_impl/* useGetCommunityUserQuery */.K_)({}, {
        enabled: !!isLoggedIn,
        select: function(data) {
            return (0,community/* communityUserService */.mT)(data);
        }
    }), userProfile = ref4.data;
    // 글 좋아요 설정
    var ref5 = (0,community_gql_impl/* useSetLikeBoardPostMutation */.Fh)({
        onMutate: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var boardPostPid, boardDetail;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                queryClient.cancelQueries([
                                    "setLikeBoardPost"
                                ])
                            ];
                        case 1:
                            _state.sent();
                            boardPostPid = data.boardPostPid;
                            return [
                                4,
                                queryClient.cancelQueries([
                                    "getBoardPost",
                                    {
                                        boardPostPid: boardPostPid
                                    }
                                ])
                            ];
                        case 2:
                            _state.sent();
                            boardDetail = queryClient.getQueryData([
                                "getBoardPost",
                                {
                                    boardPostPid: boardPostPid
                                }
                            ]);
                            if (boardDetail) {
                                queryClient.setQueryData([
                                    "getBoardPost",
                                    {
                                        boardPostPid: boardPostPid
                                    }
                                ], function() {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, boardDetail), {
                                        boardPost: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, boardDetail.boardPost), {
                                            isLikedByMe: true,
                                            likeCount: boardDetail.boardPost.likeCount + 1
                                        })
                                    });
                                });
                            }
                            return [
                                2,
                                {
                                    boardDetail: boardDetail
                                }
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }(),
        onError: function(err, _, context) {
            queryClient.setQueryData([
                "getBoardPost",
                {
                    boardPostPid: boardPostPid
                }
            ], context === null || context === void 0 ? void 0 : context.boardDetail);
        }
    }), setLikeBoardPost = ref5.mutate;
    var updatePostLikeStatus = function() {
        if (!isLoggedIn) {
            onOpenAuthModal();
            return;
        }
        return setLikeBoardPost({
            boardPostPid: boardPostPid
        }, {
            onSettled: function() {
                return onInvalidateQueryByOnSuccess(boardPostPid);
            }
        });
    };
    // 댓글 좋아요 설정
    // todo: 댓글 api 변경 후 낙관적 업데이트 추가
    var ref6 = (0,community_gql_impl/* useSetLikeBoardCommentMutation */.jQ)(), setLikeBoardComment = ref6.mutate;
    var updateCommentLikeStatus = function(boardCommentPid) {
        if (!isLoggedIn) {
            onOpenAuthModal();
            return;
        }
        return setLikeBoardComment({
            boardCommentPid: boardCommentPid
        }, {
            onSuccess: function() {
                return onInvalidateQueryByOnSuccess(boardPostPid);
            }
        });
    };
    // 댓글 등록
    var ref7 = (0,community_gql_impl/* useAddPostBoardCommentOfBoardPostMutation */.nT)({
        retry: 0
    }), addCommentOfPost = ref7.mutateAsync;
    var onSubmitCommentByPost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(content) {
            var result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isLoggedIn) {
                            onOpenAuthModal();
                            return [
                                2
                            ];
                        }
                        setAddCommentLoading(true);
                        return [
                            4,
                            addCommentOfPost({
                                request: {
                                    boardPostPid: boardPostPid,
                                    content: content
                                }
                            }, {
                                onSuccess: function() {
                                    (0,logger/* mobileLogger */.Pp)({
                                        logger: {
                                            eventName: "submit_comment",
                                            pageName: pageName
                                        }
                                    });
                                    onClearComment();
                                    onInvalidateQueryByOnSuccess(boardPostPid);
                                },
                                onSettled: function() {
                                    setAddCommentLoading(false);
                                }
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        return [
                            2,
                            result.postBoardCommentOfBoardPost
                        ];
                }
            });
        });
        return function onSubmitCommentByPost(content) {
            return _ref.apply(this, arguments);
        };
    }();
    var onInvalidateQueryByOnSuccess = function(boardPostPid) {
        queryClient.invalidateQueries([
            "getBoardPost",
            {
                boardPostPid: boardPostPid
            }
        ]);
    };
    // onChange 댓글
    var onChangeCommentInput = function(e) {
        if (!(0,RNPlugins/* isWebView */.vp)() && !isLoggedIn) {
            return;
        }
        setComment(function(prev) {
            var value = e.target.value;
            if (value.length > COMMENT_MAX_LENGTH) {
                return prev;
            }
            return value.replace(/^\s+/g, "");
        });
    };
    // 댓글 input clear
    var onClearComment = function() {
        setComment("");
    };
    // toggle 공유하기 모달
    var onToggleShareModal = function(on) {
        (0,logger/* mobileLogger */.Pp)({
            logger: {
                eventName: "post_share_click",
                pageName: pageName,
                payload: {
                    id: boardPostPid
                }
            }
        });
        setIsShareModalOpen(on);
    };
    var onOpenAuthModal = function() {
        setShowAuthModal(true);
    };
    (0,react.useEffect)(function() {
        if (isLoggedIn) refetchBoardPostDetail();
    }, [
        isLoggedIn,
        refetchBoardPostDetail
    ]);
    return {
        comment: comment,
        addCommentLoading: addCommentLoading,
        isShareModalOpen: isShareModalOpen,
        boardPostDetail: boardPostDetail,
        isBoardPostDetailLoading: isBoardPostDetailLoading,
        boardPostRefresh: boardPostRefresh,
        userProfile: userProfile,
        isLoggedIn: isLoggedIn,
        updatePostLikeStatus: updatePostLikeStatus,
        updateCommentLikeStatus: updateCommentLikeStatus,
        onSubmitCommentByPost: onSubmitCommentByPost,
        onChangeCommentInput: onChangeCommentInput,
        onToggleShareModal: onToggleShareModal,
        onClearComment: onClearComment,
        onOpenAuthModal: onOpenAuthModal,
        pageName: pageName
    };
};
/* harmony default export */ var PostDetailTemplate_useBoardPostDetailViewModel = (useBoardPostDetailViewModel);

;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Community/PostDetailTemplate/index.tsx



function PostDetailTemplate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  position: relative;\n"
    ]);
    PostDetailTemplate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PostDetailTemplate_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 26px 24px 0 24px;\n"
    ]);
    PostDetailTemplate_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}























var PostDetailTemplate = function(param) {
    var boardPostPid = param.boardPostPid, userAgent = param.userAgent;
    var ref = (0,useModal/* default */.Z)(), showModal = ref.showModal, closeModal = ref.closeModal;
    var showToast = (0,useToast/* default */.Z)().showToast;
    var ref1 = (0,usePostReportModal/* default */.ZP)(), showReportModal = ref1.showReportModal, onShowReportModal = ref1.onShowReportModal, onCloseReportModal = ref1.onCloseReportModal, reportData = ref1.reportData, reportItems = ref1.reportItems;
    var viewModel = PostDetailTemplate_useBoardPostDetailViewModel({
        boardPostPid: boardPostPid
    });
    var commentsRef = (0,react.useRef)(null);
    var updateLikePostStatus = function(isLike) {
        if (isLike) {
            viewModel.updatePostLikeStatus();
        } else {
            showToast({
                message: "이미 공감한 게시글이에요."
            });
        }
    };
    var setLikeCommentStatus = function(e, boardCommentPid, isLike) {
        e.stopPropagation();
        if (isLike) {
            viewModel.updateCommentLikeStatus(boardCommentPid);
        } else {
            showToast({
                message: "이미 공감한 댓글이에요."
            });
        }
    };
    var onScrollBottom = function() {
        setTimeout(function() {
            window.scrollTo({
                top: document.body.scrollHeight,
                behavior: "smooth"
            });
        }, 500);
    };
    var handleAddCommentByPost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(content) {
            var success;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!viewModel.addCommentLoading) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            viewModel.onSubmitCommentByPost(content)
                        ];
                    case 1:
                        success = _state.sent();
                        if (success && (0,RNPlugins/* isWebView */.vp)()) {
                            onScrollBottom();
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddCommentByPost(content) {
            return _ref.apply(this, arguments);
        };
    }();
    // 질문 신고하기
    var onReport = function(e) {
        e.stopPropagation();
        if (!viewModel.isLoggedIn) {
            return viewModel.onOpenAuthModal();
        }
        if (viewModel.boardPostDetail) {
            var ref, ref1;
            var ref2;
            onShowReportModal({
                targetId: viewModel.boardPostDetail.boardPostPid,
                targetType: ReportTemplate/* REPORT_TYPE.BOARD_POST */.Ry.BOARD_POST,
                isMine: viewModel.boardPostDetail.isMine,
                isDetailPage: true,
                isAdmin: (ref = viewModel.userProfile) === null || ref === void 0 ? void 0 : ref.isAdmin,
                attachmentTargetId: (ref2 = (ref1 = viewModel.boardPostDetail.boardPostAttachments[0]) === null || ref1 === void 0 ? void 0 : ref1.boardPostAttachmentId) !== null && ref2 !== void 0 ? ref2 : undefined
            });
        }
    };
    var onChangeShowShareModal = function() {
        viewModel.onToggleShareModal(!viewModel.isShareModalOpen);
    };
    var onShowBannedUserModal = function() {
        var ref;
        showModal({
            type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
            props: {
                title: "커뮤니티 정책을 위반했어요.",
                message: "제한 기간 동안 게시글과 댓글을 쓸 수 없어요.\n(제한 기간 : ".concat((ref = viewModel.userProfile) === null || ref === void 0 ? void 0 : ref.formattedBannedDate, ")"),
                buttons: [
                    {
                        type: modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                        label: "확인",
                        onClick: closeModal
                    }, 
                ]
            }
        });
    };
    var onClickInput = function(e) {
        var ref;
        e.stopPropagation();
        if (!viewModel.isLoggedIn) {
            return viewModel.onOpenAuthModal();
        }
        if ((ref = viewModel.userProfile) === null || ref === void 0 ? void 0 : ref.isBanned) {
            onShowBannedUserModal();
        }
    };
    if (viewModel.isBoardPostDetailLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetailTemplate_PostDetailSkeleton, {});
    if (!viewModel.boardPostDetail) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (viewModel.boardPostDetail.blinded) return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetailTemplate_DeletedPostItem, {
        title: viewModel.boardPostDetail.boardCategory.name
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "".concat(viewModel.boardPostDetail.title, " - 닥터나우"),
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.COMMUNITY.DETAIL.path */.Z6.COMMUNITY.DETAIL.path, "/").concat(viewModel.boardPostDetail.boardPostPid),
                description: "".concat(viewModel.boardPostDetail.content),
                openGraph: {
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.COMMUNITY.DETAIL.path */.Z6.COMMUNITY.DETAIL.path, "/").concat(viewModel.boardPostDetail.boardPostPid),
                    title: "".concat(viewModel.boardPostDetail.title, " - 닥터나우"),
                    description: "".concat(viewModel.boardPostDetail.content),
                    images: [
                        {
                            url: "".concat("https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-community.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                },
                twitter: {
                    handle: "@doctornow",
                    site: "@doctornow.co.kr",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalHeaderRenderer/* default */.Z, {
                isWebView: (0,RNPlugins/* isWebViewByUserAgent */.c0)(userAgent),
                appHeader: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHeader/* default */.Z, {
                    onClickBackButton: RNPlugins/* historyBack */.$i,
                    title: viewModel.boardPostDetail.boardCategory.name
                }),
                paddingTop: 0,
                children: [
                    !(0,RNPlugins/* isMobile */.tq)(userAgent) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                            visible: true,
                            path: common/* ROUTES.COMMUNITY.LIST.path */.Z6.COMMUNITY.LIST.path,
                            type: "community",
                            name: viewModel.boardPostDetail.boardCategory.name,
                            urlParameter: "?categoryId=".concat(viewModel.boardPostDetail.boardCategoryId)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostDetailTemplate_Container, {
                        isWebview: (0,RNPlugins/* isWebViewByUserAgent */.c0)(userAgent),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PullToRefresh/* default */.Z, {
                                onRefresh: viewModel.boardPostRefresh,
                                pullingContent: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetailTemplate_PostContent, {
                                            boardPostDetail: viewModel.boardPostDetail,
                                            onReport: onReport,
                                            updateLikePostStatus: updateLikePostStatus,
                                            onShowShareModal: onChangeShowShareModal
                                        }),
                                        !!viewModel.boardPostDetail.boardComments.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetailTemplate_PostComments, {
                                            commentsRef: commentsRef,
                                            boardPostDetail: viewModel.boardPostDetail,
                                            refreshPost: viewModel.boardPostRefresh,
                                            setLikeCommentStatus: setLikeCommentStatus,
                                            userProfile: viewModel.userProfile,
                                            onShowBannedUserModal: onShowBannedUserModal
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCommentInput/* default */.Z, {
                                isLoggedIn: viewModel.isLoggedIn,
                                userProfile: viewModel.userProfile,
                                comment: viewModel.comment,
                                onChangeInput: viewModel.onChangeCommentInput,
                                onSubmit: handleAddCommentByPost,
                                onClickInput: onClickInput
                            }),
                            reportItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportSelectModal/* default */.Z, {
                                isVisible: showReportModal,
                                onClose: onCloseReportModal,
                                selectList: reportItems,
                                title: (reportData === null || reportData === void 0 ? void 0 : reportData.isAdmin) ? "관리 하기" : (reportData === null || reportData === void 0 ? void 0 : reportData.isMine) ? "게시글 관리" : "신고하기"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareSelectModal/* default */.C, {
                                isVisible: viewModel.isShareModalOpen,
                                onClose: onChangeShowShareModal,
                                type: ShareSelectModal/* KAKAO_SHARE_TYPE.BOARD_POST */.Z.BOARD_POST,
                                pageName: viewModel.pageName,
                                kakaoShare: {
                                    id: viewModel.boardPostDetail.boardPostPid,
                                    title: viewModel.boardPostDetail.title,
                                    content: viewModel.boardPostDetail.content
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Community_PostDetailTemplate = (PostDetailTemplate);
var PostDetailTemplate_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-88a2577-0"
})(PostDetailTemplate_templateObject(), function(param) {
    var theme = param.theme, isWebview = param.isWebview;
    return "\n    width: 100%;\n    height: auto;\n    min-height: ".concat(isWebview ? "100vh" : "0", ";\n    background: ").concat(theme.color.gray30, ";\n  ");
});
var BreadCrumbsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-88a2577-1"
})(PostDetailTemplate_templateObject1());

;// CONCATENATED MODULE: ./src/pages/content/community/[id]/index.tsx
// PageDescription: 커뮤니티 상세 페이지


var PostDetailPage = function(param) {
    var boardPostPid = param.boardPostPid, userAgent = param.userAgent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Community_PostDetailTemplate, {
        boardPostPid: boardPostPid,
        userAgent: userAgent
    });
};
var __N_SSP = true;
/* harmony default export */ var _id_ = (PostDetailPage);


/***/ }),

/***/ 60288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ setImageUrl; },
/* harmony export */   "Kp": function() { return /* binding */ resizingImg; },
/* harmony export */   "NR": function() { return /* binding */ convertedHeicSingleImage; },
/* harmony export */   "Or": function() { return /* binding */ isImage; },
/* harmony export */   "R2": function() { return /* binding */ redirectPostImage; },
/* harmony export */   "RW": function() { return /* binding */ convertHeic; },
/* harmony export */   "VM": function() { return /* binding */ onCompressImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22710);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22970);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);
/* eslint-disable @typescript-eslint/no-var-requires */ 



var convertHeic = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var heic2any, blob, newImage;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 4838).then(__webpack_require__.t.bind(__webpack_require__, 1616, 23))
                    ];
                case 1:
                    heic2any = _state.sent().default;
                    return [
                        4,
                        heic2any({
                            blob: file,
                            toType: "image/jpeg",
                            quality: 0.8
                        })
                    ];
                case 2:
                    blob = _state.sent();
                    newImage = new File([
                        blob
                    ], file.name.split(".")[0] + ".jpeg", {
                        type: "image/jpeg",
                        lastModified: new Date().getTime()
                    });
                    return [
                        2,
                        newImage
                    ];
            }
        });
    });
    return function convertHeic(file) {
        return _ref.apply(this, arguments);
    };
}();
var convertedHeicSingleImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(originFile) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!originFile.type.includes("heic")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        convertHeic(originFile)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    return [
                        2,
                        originFile
                    ];
            }
        });
    });
    return function convertedHeicSingleImage(originFile) {
        return _ref.apply(this, arguments);
    };
}();
var setImageUrl = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var convertedImage;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!file.type.includes("heic")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        convertHeic(file)
                    ];
                case 1:
                    convertedImage = _state.sent();
                    return [
                        2,
                        Object.assign(convertedImage, {
                            blobUrl: URL.createObjectURL(convertedImage)
                        })
                    ];
                case 2:
                    return [
                        2,
                        Object.assign(file, {
                            blobUrl: URL.createObjectURL(file)
                        })
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function setImageUrl(file) {
        return _ref.apply(this, arguments);
    };
}();
var onCompressImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file, options) {
        var imageCompression, blob, compressedImage;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 3516).then(__webpack_require__.bind(__webpack_require__, 40221))
                    ];
                case 1:
                    imageCompression = _state.sent().default;
                    return [
                        4,
                        imageCompression(file, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options))
                    ];
                case 2:
                    blob = _state.sent();
                    compressedImage = new File([
                        blob
                    ], file.name.split(".")[0] + ".jpeg", {
                        type: "image/jpeg",
                        lastModified: new Date().getTime()
                    });
                    return [
                        2,
                        compressedImage
                    ];
            }
        });
    });
    return function onCompressImage(file, options) {
        return _ref.apply(this, arguments);
    };
}();
var resizingImg = function(param) {
    var originUrl = param.originUrl, width = param.width, height = param.height, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality;
    return "".concat(originUrl, "?w=").concat(width, "&h=").concat(height, "&q=").concat(quality);
};
var isImage = function(image) {
    return image.type.includes("image");
};
var redirectPostImage = function(boardPostAttachmentId) {
    return "".concat(_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .BFF_BASE_URL */ .qG, "/api/v1/board/board-post-attachments/").concat(boardPostAttachmentId, "/redirect-to-signed-url");
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6577,7160,7096,8839,4329,3267,2549,3137,677,5839,1590,9774,2888,179], function() { return __webpack_exec__(34101); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);